import queryKeys from '@/constants/queryKeys';
import { domainInterpretationGet } from '@/services/api/requests/screener';
import { useAppStore } from '@/store/useAppStore';
import { THealthDomainWithOverall } from '@/types/Health.types';
import { useQuery } from '@tanstack/react-query';

const useDomainScreenerInterpretation = (domain: THealthDomainWithOverall) => {
  const { user } = useAppStore();

  const { isLoading, data, isError, isSuccess, refetch, isRefetching } = useQuery({
    queryKey: [queryKeys.screener.domainInterpretation, domain, user?.email ?? ''],
    queryFn: async () => {
      const result = await domainInterpretationGet(domain.toUpperCase());
      return result;
    },
  });

  return { isLoading, data, isError, isSuccess, refetch, isRefetching };
};

export default useDomainScreenerInterpretation;
